import { render, staticRenderFns } from "./myActivityDetail.vue?vue&type=template&id=a9672b8c&scoped=true"
import script from "./myActivityDetail.vue?vue&type=script&lang=js"
export * from "./myActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./myActivityDetail.vue?vue&type=style&index=0&id=a9672b8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9672b8c",
  null
  
)

export default component.exports